export enum PriceGroupApprovalStatus {
    New = 1,
    Waiting = 2,
    Approve = 3,
    Reject = 4
}

